<template>
  <transition name="fade" @before-leave="beforeLeaveHandler">
    <div class="article-container" @click.stop="$emit('on-close')">
      <div class="main">
        <div class="return-btn">
          <!-- <img src="../assets/images/icon-return-popup.png" class="return" /> -->
          <!-- <Icon type="md-arrow-round-back" class="return" />
          返回 -->
        </div>
        <div class="content-container" @click.prevent.stop="showEmoji">
          <div class="img-video">
            <div class="swiper-container" v-if="detail.type == '1'">
              <swiper :options="swiperOptions" ref="mySwiper">
                <!-- Slides -->
                <swiper-slide
                  v-for="(item, index) in detail.image_list"
                  :key="index"
                >
                  <img :src="item" class="swiper-img" />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
              <!-- Custom Buttons -->
              <button class="custom-prev-btn">
                <img
                  src="@/assets/images/icon-prev-circle.png"
                  style="width: 32px; height: 32px"
                />
              </button>
              <button class="custom-next-btn">
                <img
                  src="@/assets/images/icon-next-circle.png"
                  style="width: 32px; height: 32px"
                />
              </button>
            </div>
            <div
              v-else
              style="width: 100%; height: 100%"
              @contextmenu.prevent
              @copy.prevent
              @cut.prevent
            >
              <video
                :src="detail.video"
                @contextmenu.prevent
                @copy.prevent
                autoplay="true"
                muted="true"
                loop="true"
                style="width: 100%; height: 100%; background: #000000"
                controls
              ></video>
            </div>
          </div>
          <div class="desc-container">
            <!-- 右侧顶部功能区 -->
            <div class="right-top">
              <div class="nick-avatar-box">
                <img @click.prevent.stop="onAvatarClick(detail.member.code || '')" :src="detail.member.avatar | default_avatar" class="avatar" />
                <div class="nick-box">
                  <div class="nick">
                    {{ detail.member.nickname || detail.member.username || "" }}
                  </div>
                </div>
              </div>
              <div class="btn-box">
                <!-- <div class="like-box" @click.prevent.stop="onPostsLike">
                  <img
                    :src="
                      detail.is_zan == 1
                        ? require('../assets/images/icon-liked-posts.png')
                        : require('../assets/images/icon-like-popup.png')
                    "
                    class="like-icon"
                  />
                  <div class="like-num">{{ detail.zan_count || 0 }}</div>
                </div>
                <div class="favorite-box" @click.prevent.stop="onPostsCollect">
                  <img
                    :src="
                      detail.is_collect == 1
                        ? require('../assets/images/icon-favorited-posts.png')
                        : require('../assets/images/icon-favorite.png')
                    "
                    class="favorite-icon"
                  />
                  <div class="favorite-num">
                    {{ detail.collect_count || 0 }}
                  </div>
                </div>
                <Poptip
                  placement="bottom"
                  trigger="hover"
                >
                  <template #content>
                    <div class="pop-share">
                      <img
                        src="../assets/images/icon-link-share.png"
                        class="link-icon"
                      />复制分享链接
                    </div>
                  </template>
                  <div @click.prevent.stop="onCopyLink"
                    class="share-btn"
                  >
                    <img
                      src="../assets/images/icon-share-square.png"
                      class="share-icon"
                    />
                  </div>
                </Poptip> -->
                <Button v-if="!is_login || (userInfo.code != detail.member.code)"
                  :class="[
                    detail.is_follow == 1 ? 'follow-btn' : 'unfollow-btn',
                  ]"
                  @click.prevent.stop="onFllowUser" shape="circle"
                  >{{ detail.is_follow == 1 ? "Following" : "Follow" }}</Button
                >
              </div>
            </div>
            <!-- 评论区|描述|标签 -->
            <div ref="contentBox" class="content-box">
              <div class="content-main">
                <!-- 标题 -->
                <div class="content-title">{{ detail.title }}</div>
                <!-- 时间|浏览量 -->
                <div class="time-view-box">
                  <div class="time">Published {{ detail.create_time | enDate }}</div>
                  <div class="view-box">
                    <img
                      src="../assets/images/icon-view-popup.png"
                      class="view-icon"
                    />
                    <span>{{ detail.view_times }} views</span>
                  </div>
                </div>
                <!-- 内容 -->
                <div class="desc-content" v-html="detail.content"></div>
                <!-- 标签 -->
                <!-- <div class="tags-box">
                                    <div class="tags-item" v-for="item in 5" :key="item">#标签{{ item }}</div>
                                </div> -->
                <!-- 评论区 -->
                <div class="comment-box">
                  <div class="comment-title">
                    COMMENTS
                    <span class="comment-count"
                      >({{ detail.comment_count || 0 }})</span
                    >
                  </div>
                  <div class="comment-main">
                    <!-- 评论主体 -->
                    <template v-if="comment_list.length > 0">

                      <div
                        class="comment-item-box"
                        v-for="(item, index) in comment_list"
                        :key="index"
                      >
                        <img
                          :src="item.frommember.avatar | default_avatar"
                          class="comment-avatar" @click.prevent.stop="onAvatarClick(item.frommember.code || '')"
                        />
                        <div style="flex: 1; overflow-x: hidden">
                          <div class="comment-nick-box">
                            <div class="comment-nick">
                              <template>
                                {{
                                  item.frommember.nickname ||
                                  item.frommember.username
                                }}<span
                                  v-if="
                                    item.frommember.username &&
                                    item.frommember.username == detail.member.username
                                  "
                                  class="comment-nick-tag"
                                  >Author</span
                                >
                              </template>
                            </div>
                            <!-- <div v-if="item.from_user_id === userInfo.id" @click.prevent.stop="onMoreClick(index)" class="nick-more-menu">
                              <img src="../assets/images/icon-more-comment.png" />
                            </div> -->
                          </div>
                          <div class="comment-content">{{ item.content }}</div>
                          <div class="comment-time">{{ item.create_time|duration_text }}</div>
                          <div class="comment-like-count">
                            <div
                              class="comment-like-count-item-left"
                              @click.prevent.stop="onCommentLike(item.uuid)"
                            >
                              <img
                                :src="
                                  item.is_zan == 1
                                    ? require('../assets/images/icon-liked-posts.png')
                                    : require('../assets/images/icon-like-popup.png')
                                "
                                class="like-count-icon"
                              />
                              <span>{{ item.zan_count }} like</span>
                            </div>
                            <div
                              class="comment-like-count-item-right"
                              @click.prevent.stop="onReplyClick(item)"
                            >
                              <img
                                src="../assets/images/icon-reply-popup.png"
                                class="like-count-icon"
                              />
                              <span>{{ item.reply_count }} comments</span>
                            </div>
                            <div v-if="item.from_user_id === userInfo.id" @click.prevent.stop="onDeleteComment(item,index)" class="delete-btn">
                              <img src="../assets/images/icon-trash.png" />Delete Comment
                            </div>
                          </div>
                          <!-- 评论回复 -->
                          <template v-if="item.children.length > 0">
                            <div
                              class="comment-child-box"
                              v-for="(child, i) in (item.showAllReplies ? item.children : [item.children[0]])"
                              :key="i"
                            >
                              <img
                                :src="child.frommember.avatar | default_avatar"
                                class="comment-avatar" @click="onAvatarClick(child.frommember.code || '')"
                              />
                              <div class="nick-box">
                                <div class="nick-container">
                                  <div class="comment-nick-box">
                                    <div style="display:flex;">
                                      <div class="comment-nick">
                                        {{
                                          child.frommember.nickname ||
                                          child.frommember.username
                                        }}<span
                                          v-if="
                                            child.frommember.username ==
                                            detail.member.username
                                          "
                                          class="comment-nick-tag"
                                          >Author</span
                                        >
                                      </div>
                                      <div
                                        v-if="
                                          child.tomember.username !=
                                          item.frommember.username
                                        "
                                        style="
                                          flex: 1;
                                          color: #858585;
                                          font-size: 16px;
                                          white-space: nowrap;
                                        "
                                      >
                                        Replied to<span style="padding-left: 10px">{{
                                          child.tomember.nickname ||
                                          child.tomember.username
                                        }}</span>
                                        <span
                                          v-if="
                                            child.tomember.username ==
                                            detail.member.username
                                          "
                                          class="comment-nick-tag"
                                          >Author</span
                                        >
                                      </div>
                                    </div>
                                    <!-- <div v-if="child.from_user_id === userInfo.id" @click.prevent.stop="onMoreClick(index,i)" class="nick-more-menu">
                                      <img src="../assets/images/icon-more-comment.png" />
                                      <div v-if="child.show_delete_comment" @mouseleave="onMoreClick(index,i)" @click.prevent.stop="onDeleteComment(child,i,true)" class="delete-btn">Delete Comment</div>
                                    </div> -->
                                  </div>
                                </div>
                                <div class="comment-content">
                                  {{ child.content }}
                                </div>
                                <div class="comment-time">
                                  {{ child.create_time|duration_text }}
                                </div>
                                <div class="comment-like-count-box">
                                  <div
                                    class="comment-like-count-item-left"
                                    @click.prevent.stop="onCommentLike(child.uuid)"
                                  >
                                    <img
                                      :src="
                                        child.is_zan
                                          ? require('../assets/images/icon-liked-posts.png')
                                          : require('../assets/images/icon-like-popup.png')
                                      "
                                      class="comment-like-count-icon"
                                    />
                                    <span>{{ child.zan_count }} like</span>
                                  </div>
                                  <div
                                    class="comment-like-count-item-right"
                                    @click.prevent.stop="onReplyClick(child)"
                                  >
                                    <img
                                      src="../assets/images/icon-reply-popup.png"
                                      class="comment-like-count-icon"
                                    />
                                    <!-- <span>5</span> -->
                                  </div>
                                  <div v-if="child.from_user_id === userInfo.id" @click.prevent.stop="onDeleteComment(child,i,true)" class="delete-btn">
                                    <img src="../assets/images/icon-trash.png" />Delete Comment
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="item.children.length>1" @click.prevent.stop="toggleReplies(index)" class="more-comment">{{ item.showAllReplies ? 'Hide' : `Expand ${item.children.length - 1} comments` }}<Icon :type="item.showAllReplies ? 'ios-arrow-up' :'ios-arrow-down'" /></div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div ref="replyBox" v-show="is_replying" class="reply-box">
              <div class="reply-to">Reply: {{reply_comment.reply_name}}</div>
              <div class="reply-content">{{reply_comment.reply_content}}</div>
            </div>
            <div class="comment-form">
              <div v-if="!enter_input" class="ready-comment-mode">
                <div class="input" @click.prevent.stop="enter_input=true">
                  <span>Write your comment</span>
                </div>
                <div class="function-btn-box">
                  <div class="btn-items" @click.prevent.stop="onPostsCollect">
                    <img :src="detail.is_collect == 1
                        ? require('../assets/images/icon-collect-popup-active.png')
                        : require('../assets/images/icon-collect-popup.png')"/>{{ detail.collect_count || 0 }}
                  </div>
                  <div class="btn-items" @click.prevent.stop="onPostsLike">
                    <img :src="detail.is_zan == 1
                        ? require('../assets/images/icon-like-popup-active.png')
                        : require('../assets/images/icon-like-popup.png')"/>{{ detail.zan_count || 0 }}
                  </div>
                  <div class="btn-items" @click.prevent.stop="onCopyLink">
                    <img src="../assets/images/icon-share-popup.png" />Share
                  </div>
                </div>
              </div>
              <template v-else>
                <div class="comment-input-box" @click.prevent.stop="onInputClick">
                  <div v-if="!is_login" class="un-login">Please login first</div>
                  <input v-else ref="commentInput"
                    class="comment-input"
                    placeholder="Say something..."
                    v-model="comment_content" @click.prevent.stop="showEmoji(true)"
                  />
                </div>
                <div class="function-box">
                  <!-- <img src="" class="icon-emoji" /> -->
                  <!-- 引入EMOJI表情库 -->
                  <emoji-picker @emoji="append">
                    <button id="emojiBtn" ref="emojiBtn"
                      class="icon-emoji"
                      slot="emoji-invoker"
                      slot-scope="{ events: { click: clickEvent } }"
                      @click.stop="($event)=>{
                        clickEvent($event);
                        show_emoji = !show_emoji;
                      }"
                    ></button>
                    <div
                      slot="emoji-picker"
                      slot-scope="{ emojis, insert, display }"
                    >
                      <div
                        class="emoji-picker"
                        :style="{ top: (display.y) + 'px', left: (display.x) + 'px' }"
                      >
                        <!-- <div class="emoji-picker__search">
                          <input type="text" v-model="search" v-focus />
                        </div> -->
                        <div>
                          <div
                            v-for="(emojiGroup, category) in emojis"
                            :key="category"
                          >
                            <h5>{{ category }}</h5>
                            <div class="emojis">
                              <span
                                v-for="(emoji, emojiName) in emojiGroup"
                                :key="emojiName"
                                @click.stop="insert(emoji)"
                                :title="emojiName"
                                >{{ emoji }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </emoji-picker>
                  <div class="form-btn-box">
                    <Button v-if="is_replying" class="cancel-btn" @click.prevent.stop="is_replying=false">Cancel</Button>
                    <Button class="submit-btn" @click.prevent.stop="onReplyPosts">Post comment</Button>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <login-pop v-if="show_login" @close-login="closeLoginpop"></login-pop>
        </div>
        <div style="margin-top: 30px">
          <Icon
            type="md-close"
            size="19"
            @click.prevent.stop="$emit('on-close')"
            style="cursor: pointer;color:white;background:rgba(0,0,0,0.5);border-radius:50%;padding:13px;"
          />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  GetPostsByUUID,
  GetPostsCommentList,
  ReplyPosts,
  PostsLike,
  PostsCollect,
  FollowUser,
  CommentLike,
  CommentDelete,
  GetMatchPostDetail,
  GetMatchPostsCommentList,
  MatchReplyPosts,
  MatchPostsLike,
  MatchPostsCollect,
  MatchPostsCommentLike,
  MatchPostsCommentDelete
} from "@/api/social";
import { EmojiPicker } from "vue-emoji-picker";
import {mapState} from 'vuex';
import LoginPop from '@/components/LoginPop';

export default {
  name: "ArticleDetail",
  components: {
    swiper,
    swiperSlide,
    EmojiPicker,LoginPop
  },
  props: {
    uuid: {
      type: String | Number,
      default: () => {
        return "";
      },
    },
    postType:{
      type: String | Number,
      default: () => {
        return 1;
      },

    }
  },

  beforeDestroy() {
    document.body.style.overflow = '';
  document.body.style.height = '';
  document.body.style.width = '';
  },
  created() {},
  async mounted() {
    // 锁定页面滚动
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    console.log('this.user_info',this.userInfo);
    await this.onGetPosts();
    await this.onGetPostsCommentList();
  },
  computed:{
    ...mapState(['userInfo']),
    is_login(){
      return this.$store.state.is_login;
    }
  },
  watch: {
    is_replying(news,olds){
      // if(news){
        this.heightCpt();
      // }
      if(!news){
        this.reply_comment = {};
        this.select_quote_uuid = '';
        this.select_post_uuid = '';
      }
    },
    enter_input(news,olds){
      if(news){
        this.$nextTick(()=>{
          if(this.$refs.commentInput){
            this.$refs.commentInput.focus();
          }
        })
      }
    }
  },
  data() {
    return {
      detail: {
        type: "1",
        image_list: [],
        member: {},
      },
      is_share_click: false,
      swiperOptions: {
        // 核心配置
        slidesPerView: 1, // 每页显示 1 张幻灯片
        centeredSlides: true, // 当前幻灯片居中显示
        spaceBetween: 20, // 幻灯片间距
        loop: true, // 启用循环模式
        loopedSlides: 0,
        grabCursor: true, // 拖动时显示抓手光标
        autoplay: {
          delay: 3000, // 3秒切换
          disableOnInteraction: false, // 手动滑动后继续自动播放
        },
        // 导航按钮配置
        navigation: {
          prevEl: ".custom-prev-btn",
          nextEl: ".custom-next-btn",
        },
        pagination: {
          el: ".swiper-pagination", // 指定分页器容器选择器
          type: "bullets", // 类型：bullets（圆点）、fraction（分数）、progress（进度条）等
          clickable: true, // 允许点击分页器切换幻灯片
          bulletActiveClass: "my-swiper-pagination-active", // 自定义激活状态类名
        },
      },
      comment_list: [],
      comment_content: "",
      select_post_uuid: "",
      select_quote_uuid: "",
      reply_status: false,
      is_replying: false,
      org_height:'',
      reply_comment:{},
      show_delete_comment:false,
      show_login:false,
      show_emoji:false,
      enter_input:false
    };
  },
  methods: {
    closeLoginpop(){
				this.show_login = false;
			},
    async onDeleteComment(item,index,child=false){
      console.log('item',item);
      try{
        const {uuid} = this;
        const param = {};
        param.post_uuid = uuid;
        param.comment_uuid = item.uuid;
        if(this.postType == 1){
          await CommentDelete(param);
        }else{
          await MatchPostsCommentDelete(param);
        }
        this.$layer.msg('Opreation success');
        this.onGetPostsCommentList();
      }catch(e){
        console.log('err-delete-comment',e);
      }
    },
    onMoreClick(index,child=null){
      if(child == null){
        console.log('child',child);
        const {show_delete_comment} = this.comment_list[index];
        this.$set(this.comment_list[index],'show_delete_comment',!show_delete_comment);
      }else{
        const {show_delete_comment} = this.comment_list[index].children[child];
        this.$set(this.comment_list[index].children[child],'show_delete_comment',!show_delete_comment);
      }
    },
    onInputClick(){
      if(!this.is_login){
        this.$layer.msg('Please login first');
        this.show_login = true;
        //this.$router.push({name:"Login"});
      }
    },
    heightCpt(){
      this.$nextTick(() => {
          const contentBox = this.$refs.contentBox.getBoundingClientRect();
          if (!contentBox) return;
          const replyBox = this.$refs.replyBox.getBoundingClientRect();
          if (this.is_replying && replyBox) {
            const newHeight = contentBox.height - replyBox.height;
            this.$refs.contentBox.style.height = `${newHeight.toFixed(2)}px`;
            // this.$refs.contentBox.style['max-height'] = `${newHeight.toFixed(2)}px`;
          } else {
            this.$refs.contentBox.style.height = this.org_height;
            this.$refs.contentBox.style['max-height'] = this.org_height;
          }
      });
    },
    onAvatarClick(code){
      const uri = `${window.location.origin}/userProfile/${code}`;
      console.log('uri',uri);
      window.open(uri,'_blank');
    },
    toggleReplies(index) {
      this.$set(this.comment_list[index], 'showAllReplies', !this.comment_list[index].showAllReplies);
    },
    showEmoji(isInputClick=false){
      console.log('this.show_emoji',this.show_emoji);
      if(this.show_emoji){
        console.log('aaa',this.show_emoji);
        this.$nextTick(()=>{
          this.$refs.emojiBtn.click();
          // const btn = document.getElementById('emojiBtn')
          // console.log('btn===>',btn);
          // if(btn){
          //   btn.click();
          // }
        })
      }
      console.log('isInputClick',isInputClick);
      console.log('enter_input',this.enter_input);
      if(this.enter_input && (typeof isInputClick != 'boolean' || isInputClick === false)){
        this.enter_input = !this.enter_input;
      }
    },
    clickEvent(e) {
      console.log("clickEvent", e);
      this.show_emoji = !this.show_emoji;
    },
    append(emoji) {
      console.log("emoji", emoji);
      this.comment_content += emoji;
    },
    async onCommentLike(uuid) {
      try {
        console.log("uuid", uuid);
        if(!this.is_login){
          this.$layer.msg('Please login first');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        if(this.postType == 1){
          await CommentLike({ uuid });
        }else{
          await MatchPostsCommentLike({uuid});
        }
        this.$layer.msg("Operation success");
        this.onGetPostsCommentList();
      } catch (e) {
        console.log("Operation failed", e);
        this.$layer.msg("Operation failed");
      }
    },
    async onFllowUser() {
      try {
        if(!this.is_login){
          this.$layer.msg('Please login first');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        await FollowUser({ follow_id: this.detail.user_id });
        this.$layer.msg("Operation success");
        this.onGetPosts();
      } catch (e) {
        console.log("Operation failed", e);
        this.$layer.msg("Operation failed");
      }
    },
    beforeLeaveHandler(el) {
      // 定义随机方向参数
      const dx = (Math.random() - 0.5) * 200; // 水平方向随机偏移（-100~+100）
      const dy = (Math.random() - 0.5) * 100; // 垂直方向随机偏移（-50~+50）
      const scale = Math.random() * 0.5 + 0.1; // 随机缩放比例（0.1~0.6）

      // 动态设置元素样式
      el.style.transition = "all 0.3s ease-out";
      el.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
      el.style.opacity = "0";
    },
    async onPostsCollect() {
      try {
        if(!this.is_login){
          this.$layer.msg('Please login first');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        if(this.postType == 1){
          await PostsCollect({ uuid: this.uuid });
        }else{
          await MatchPostsCollect({ uuid: this.uuid });
        }
        const msg = 'Operation success';
        this.$layer.msg(msg);
        this.onGetPosts();
      } catch (e) {
        console.log("Operation failed", e);
        this.$layer.msg("Operation failed");
      }
    },
    async onPostsLike() {
      try {
        if(!this.is_login){
          this.$layer.msg('Please login first');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        if(this.postType == 1){
          await PostsLike({ uuid: this.uuid });
        }else{
          await MatchPostsLike({ uuid: this.uuid });
        }
        const msg = 'Operation success';
        this.$layer.msg(msg);
        this.onGetPosts();
      } catch (e) {
        console.log("Operation failed", e);
        this.$layer.msg("Operation failed");
      }
    },
    onReplyClick(item) {
      console.log('item',item);
      // this.reply_comment.reply_name = item.frommember.nickname || item.frommember.username;
      // this.reply_comment.reply_content = item.content;
      this.$set(this.reply_comment,'reply_name',item.frommember.nickname || item.frommember.username);
      this.$set(this.reply_comment,'reply_content',item.content);
      this.select_post_uuid = this.uuid;
      this.select_quote_uuid = item.uuid;
      this.is_replying = true;
    },
    async onReplyPosts() {
      try {
        if (this.reply_status) {
          return;
        }
        const { uuid, comment_content, select_post_uuid, select_quote_uuid } =
          this;
        if (!comment_content) {
          return;
        }
        this.reply_status = true;
        const param = {};
        param.post_uuid = select_post_uuid || uuid;
        param.content = comment_content;
        param.quote_uuid = select_quote_uuid;
        if(this.postType == 1){
          await ReplyPosts(param);
        }else{
          await MatchReplyPosts(param)
        }
        this.onGetPostsCommentList();
        this.$layer.msg("Operation success");
        this.comment_content = "";
        this.select_post_uuid = "";
        this.select_quote_uuid = "";
        this.is_replying = false;
        this.reply_comment = {};
      } catch (e) {
        this.$layer.msg("Operation failed");
        return;
      } finally {
        this.reply_status = false;
        this.onGetPosts()
      }
    },
    async onGetPostsCommentList() {
      const {postType} = this;
      switch(postType){
        case 1:{
          const { uuid } = this;
          const { data } = await GetPostsCommentList({ uuid });
          console.log("data", data);
          this.comment_list = data;
          break;
        }
        case 2:{
          const { uuid } = this;
          const { data } = await GetMatchPostsCommentList({ uuid });
          console.log("data", data);
          this.comment_list = data;
        }
      }
    },
    async onGetPosts() {
      try{
        const { uuid,postType } = this;
        let res = {};
        switch(postType){
          case 1:{
            const { data } = await GetPostsByUUID({ uuid });
            res = data;
            break;
          }
          case 2:{
            const { data } = await GetMatchPostDetail({ uuid });
            res = data;
            res.type = 1;
            break;
          }
        }
        this.swiperOptions.loopedSlides = res.image_list.length;
        this.detail = res;
      }catch(e){
        this.$layer.msg(e.msg)
        this.$emit('on-close');
      }
    },
    onShareClick(type) {
      console.log("type", type);
      const status = type == "cancel" ? false : true;
      this.is_share_click = status;
      console.log("aaa", this.is_share_click);
    },
    async onCopyLink() {
      if(this.postType == 1){
        const text = `${window.location.origin}/${this.uuid}`;
        await navigator.clipboard.writeText(text);
      }else{
        const text1 = `${window.location.href}/?post_uuid=${this.uuid}`;
        await navigator.clipboard.writeText(text1);
      }

      this.$layer.msg("Operation success");
      this.is_share_click = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.article-container {
  width: 100%;
  height:100%;
  position: fixed;
  // background: #f7f7f7;
  background:rgba(0,0,0,0.25);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  overflow-y: auto;
  font-family: 'MicrosoftYaHei';
  &::-webkit-scrollbar{
    display:none;
  }
  // overflow:hidden;
  transform-origin: center;
  animation: centerExpand 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94); /* 添加缓动曲线 */
  @keyframes centerExpand {
    0% {
      transform: scale(0.8) translateY(-10px); /* 初始状态缩小+上移 */
      opacity: 0;
    }
    100% {
      transform: scale(1) translateY(0); /* 完全显示 */
      opacity: 1;
    }
  }

  &.fade-leave-active {
    transition: all 0.3s ease-out;
  }

  .main {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    margin-top: 15px;
    padding: 0 80px;

    .return-btn {
      margin-top: 30px;
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 22px;
    }

    .content-container {
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      width: 1100px;
      max-height:860px;
      background: #ffffff;
      // border-top-left-radius: 20px;
      // padding: 30px 0 18px 25px;
      border-radius:20px;
      padding:15px 0 15px 15px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;

      .img-video {
        width: 620px;
        height: 830px;
        background: #f7f7f7;
        border-radius: 10px;
        overflow: hidden;
      }

      .desc-container {
        width: calc(1100px - 620px);
        display:flex;
        flex-direction:column;
        height:100%;
        margin-left:25px;
        margin-right:15px;

        .right-top {
          border-bottom: 1px solid #ececec;
          width: 100%;
          margin-top: 16px;
          // padding-left: 41px;
          padding-bottom: 20px;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;

          .nick-avatar-box {
            display: flex;
            justify-content: start;
            align-items: center;

            .avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              cursor:pointer;
              object-fit:cover;
            }

            .nick-box {
              margin-left: 10px;

              .nick {
                color: #1c1f23;
                font-size: 16px;
              }

              .job {
                color: #5c5c5c;
                font-size: 12px;
              }
            }
          }

          .btn-box {
            display: flex;
            justify-content: end;
            align-items: center;

            .like-box {
              margin: 0 4px;
              width: 40px;
              height: 40px;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid #e8e8e9;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              cursor: pointer;

              &:hover{
                background:#f4f6f6;
              }

              .like-icon {
                width: 18px;
                height: 18px;
              }

              .like-num {
                width: 100%;
                text-align: center;
                color: #5c5c5c;
                font-size: 11px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }

            .favorite-box {
              margin: 0 4px;
              width: 40px;
              height: 40px;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid #e8e8e9;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              cursor: pointer;
              &:hover{
                background:#f4f6f6;
              }
              .favorite-icon {
                width: 18px;
                height: 18px;
              }

              .favorite-num {
                width: 100%;
                text-align: center;
                color: #5c5c5c;
                font-size: 11px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }

            .pop-share {
              background: rgba(0, 0, 0, 0.8);
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;

              .link-icon {
                width: 18px;
                height: 18px;
                margin-right: 5px;
              }
            }

            .share-btn {
              margin: 0 8px;
              width: 40px;
              height: 40px;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid #e8e8e9;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              &:hover{
                background:#f4f6f6;
              }

              .share-icon {
                width: 14px;
                height: 15px;
              }
            }

            .follow-btn {
              background: transparent;
              color: #000000;
              border: 1px solid #e0e0e0;
              // width: 100px;
              // height: 40px;
            }
            .unfollow-btn {
              background: #0d0c22;
              color: #ffffff;
              // width: 100px;
              // height: 40px;
            }
          }
        }

        .content-box {
          width: 100%;
          height:100%;
          max-height: 640px;
          flex:1;
          overflow-y:auto;
          transition:height 0.3s ease;
          border-bottom: 1px solid #ececec;
          &::-webkit-scrollbar{
            display:none;
          }

          .content-main {
            padding: 25px 0 0 0;
            width: 100%;

            .content-title {
              font-weight: bold;
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 20px;
              color:#000000;
            }

            .time-view-box {
              display: flex;
              align-items: center;
              color: #5c5c5c;
              font-size: 14px;
              margin-top: 10px;
              width: 100%;

              .time {
                margin-right: 20px;
                // flex:0 0 57%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .view-box {
                display: flex;
                align-items: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                .view-icon {
                  width: 19px;
                  height: 19px;
                }
              }
            }

            .desc-content {
              color: #333333;
              font-size: 16px;
              margin-top: 25px;
              padding-bottom: 20px;
              white-space: pre-wrap;
              word-wrap:break-word;
            }

            .comment-box {
              margin-top: 20px;
              width: 100%;

              .comment-title {
                color: #0f0f0f;
                font-size: 16px;
                padding-bottom:16px;
                border-bottom:1px solid #ececec;

                .comment-count {
                  color: #808080;
                  font-size: 14px;
                }
              }

              .comment-main {
                margin-top: 20px;

                .comment-item-box {
                  display: flex;
                  justify-content: flex-start;
                  margin-bottom: 25px;
                  max-width: 100%;
                  overflow: hidden;
                  white-space: pre-wrap;

                  > div {
                    flex: 1;
                  }

                  .comment-avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-right: 10px;
                    object-fit:cover;
                  }

                  .comment-nick-box{
                    display:flex;
                    justify-content: space-between;
                    align-items:center;
                    .comment-nick {
                      width: 100%;
                      margin-right: 10px;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      color: #858585;
                      font-size: 14px;
                      display: flex;
                      align-items: center;
                      max-width: 200px;

                      .comment-nick-tag {
                        margin-left: 10px;
                        margin-right: 15px;
                        border-radius: 10px;
                        background: #f7f7f7;
                        font-size: 12px;
                        color: #858585;
                        padding: 5px;
                      }

                    }

                    .nick-more-menu{
                        width:23px;
                        height: 23px;
                        display:flex;
                        justify-content:center;
                        align-items:center;
                        position:relative;
                        img{
                          width:15px;
                          height:15px;
                        }
                        &:hover{
                          background:#f5f5f5;
                          border-radius:100%;
                        }
                        &.active{
                          background:#f5f5f5;
                          border-radius:100%;
                        }
                    }
                  }

                  .comment-content {
                    width: 100%;
                    color: #1a1a1a;
                    font-size: 14px;
                  }

                  .comment-time {
                    margin-top: 5px;
                    color: #808080;
                    font-size: 12px;
                  }

                  .comment-like-count {
                    display: flex;
                    align-items: center;
                    white-space:nowrap;
                    column-gap:17px;
                    margin-top: 10px;

                    .comment-like-count-item-left {
                      display: flex;
                      align-items: center;
                      // margin-right: 20px;
                      cursor: pointer;
                    }

                    .comment-like-count-item-right {
                      display: flex;
                      align-items: center;
                      cursor: pointer;
                    }

                    .like-count-icon {
                      width: 18px;
                      height: 18px;
                      margin-right: 5px;
                      cursor: pointer;
                    }
                  }

                  .delete-btn{
                    display:flex;
                    align-items:center;
                    column-gap:3px;
                    color:#4d4d4d;
                    font-size:12px;
                    img{
                      width:20px;
                      height:20px;
                    }
                    cursor:pointer;
                  }

                  .comment-child-box {
                    display: flex;
                    justify-content: start;
                    margin-top: 20px;

                    .nick-box {
                      flex: 1;
                      white-space: pre-wrap;
                      overflow: auto;
                      .nick-container {
                        display: flex;
                        align-items: center;
                        justify-content: start;
                        width: 100%;
                        .comment-nick-box{
                          display:flex;
                          justify-content: space-between;
                          align-items:center;
                          width:100%;

                          .nick-more-menu{
                            width:23px;
                            height: 23px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            position:relative;
                            img{
                              width:15px;
                              height:15px;
                            }
                            &:hover{
                              background:#f5f5f5;
                              border-radius:100%;
                            }
                            &.active{
                              background:#f5f5f5;
                              border-radius:100%;
                            }
                            // .delete-btn{
                            //   width:103px;
                            //   height:40px;
                            //   display:flex;
                            //   justify-content:center;
                            //   align-items:center;
                            //   background:#ffffff;
                            //   color:#000000;
                            //   border-radius:10px;
                            //   box-shadow:0px 0px 6px 0px #e0e0e0;
                            //   position:absolute;
                            //   left:-350%;
                            //   right:0;
                            //   bottom:-200%;
                            //   cursor:pointer;
                            // }
                        }
                          .comment-nick {
                            // width: 100%;
                            margin-right: 10px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            color: #858585;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            // flex:1;
                            max-width: 180px;

                            .comment-nick-tag {
                              margin-left: 10px;
                              border-radius: 10px;
                              background: #f7f7f7;
                              font-size: 12px;
                              color: #858585;
                              padding: 5px;
                            }
                          }
                          .comment-nick-tag {
                            margin-left: 10px;
                            border-radius: 10px;
                            background: #f7f7f7;
                            font-size: 12px;
                            color: #858585;
                            padding: 5px;
                          }
                        }
                      }
                    }

                    .comment-avatar {
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      margin-right: 10px;
                      object-fit:cover;
                    }

                    .comment-content {
                      width: 100%;
                      color: #1a1a1a;
                      font-size: 14px;
                    }

                    .comment-time {
                      margin-top: 5px;
                      color: #808080;
                      font-size: 12px;
                    }

                    .comment-like-count-box {
                      display: flex;
                      align-items: center;
                      column-gap:17px;
                      margin-top: 10px;
                      color:#4d4d4d;

                      .comment-like-count-item-left {
                        display: flex;
                        align-items: center;
                        // margin-right: 20px;
                        cursor: pointer;
                      }

                      .comment-like-count-item-right {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                      }

                      .comment-like-count-icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 5px;
                      }

                      .delete-btn{
                        display:flex;
                        align-items:center;
                        column-gap:3px;
                        color:#4d4d4d;
                        font-size:12px;
                        img{
                          width:20px;
                          height:20px;
                        }
                        cursor:pointer;
                      }
                    }
                  }

                  .more-comment {
                    color: #13386c;
                    font-size: 14px;
                    margin-top: 10px;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }

        .reply-box{
          margin-top:20px;
          margin-left:21px;
          font-size:14px;
          .reply-to{
            color:#858585;
          }
          .reply-content{
            color:#333333;
          }
        }

        .comment-form {
          padding: 15px 20px 10px 0px;
          .ready-comment-mode{
            display:flex;
            align-items:center;
            column-gap:26px;
            .input{
              flex:1;
              border-radius:23px;
              background:#f7f7f7;
              display:flex;
              height:45px;
              line-height:45px;
              color:#808080;
              span{
                margin-left:20px;
              }
            }
            .function-btn-box{
              display:flex;
              align-items:center;
              column-gap:13px;
              .btn-items{
                display:flex;
                align-items:center;
                color:#000000;
                font-size:14px;
                cursor:pointer;
                img{
                  width:20px;
                  height:20px;
                  margin-right:3px;
                }
              }
            }
          }
          .comment-input-box {
            height: 45px;
            background: #f7f7f7;
            border-radius: 23px 23px 23px 23px;
            display: flex;
            align-items: center;

            .un-login{
              color:#999999;
              font-size:14px;
              margin-left:20px;
            }

            .comment-input {
              border: none;
              outline: none;
              background: transparent;
              margin-left: 20px;
              width: 100%;
              padding-right: 20px;
            }
          }

          .function-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            // position:relative;

            .icon-emoji {
              width: 26px;
              height: 26px;
              margin-left: 20px;
              background-image: url(../assets/images/icon-emoji-list-popup.png);
              background-repeat: no-repeat;
              background-size: cover;
              border: none;
            }

            Button {
              background: transparent;
            }

            .emoji-invoker {
              position: absolute;
              top: 0.5rem;
              right: 0.5rem;
              width: 1.5rem;
              height: 1.5rem;
              border-radius: 50%;
              cursor: pointer;
              transition: all 0.2s;
              padding: 0;
              background: transparent;
              border: 0;
            }
            .emoji-invoker:hover {
              transform: scale(1.1);
            }
            // .emoji-invoker > svg {
            //   fill: #b1c6d0;
            // }

            .emoji-picker {
              position: absolute;
              z-index: 1;
              font-family: Montserrat;
              border: 1px solid #ccc;
              width: 30rem;
              height: 20rem;
              overflow: scroll;
              padding: 1rem;
              box-sizing: border-box;
              border-radius: 0.5rem;
              background: #fff;
              box-shadow: 1px 1px 8px #c7dbe6;
              top: 430px !important;
              left: 1000px !important;
            }
            .emoji-picker__search {
              display: none;
            }
            .emoji-picker__search > input {
              flex: 1;
              border-radius: 10rem;
              border: 1px solid #ccc;
              padding: 0.5rem 1rem;
              outline: none;
            }
            .emoji-picker h5 {
              margin-bottom: 0;
              color: #b1b1b1;
              text-transform: uppercase;
              font-size: 0.8rem;
              cursor: default;
            }
            .emoji-picker .emojis {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            }
            .emoji-picker .emojis:after {
              content: "";
              flex: auto;
            }
            .emoji-picker .emojis span {
              padding: 0.2rem;
              cursor: pointer;
              border-radius: 5px;
            }
            .emoji-picker .emojis span:hover {
              background: #ececec;
              cursor: pointer;
            }

            .form-btn-box{
              .cancel-btn{
                border-radius:10px;
                margin-right:10px;
                border:1px solid #ebebeb;
              }
              .submit-btn {
                background: #000000;
                border: none;
                color: #ffffff;
                border-radius: 10px;
              }
            }
          }
        }
      }
    }
  }
}

::v-deep .ivu-poptip-arrow:after {
  border-bottom-color: rgba(0, 0, 0, 0.9) !important;
}

::v-deep .ivu-poptip-inner {
  background-color: rgba(0, 0, 0, 0.9) !important;
  border-radius: 15px;
}

/**swiper样式调整开始 */
.swiper-container {
  position: relative;
  /* 确保按钮定位参考容器 */
  width: 100%;
  height: 830px;
  overflow: hidden;
  border-radius: 10px;
  /* 允许前后幻灯片溢出显示 */
}

.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* 幻灯片宽度占容器的 80% */
  // background: #000000;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.swiper-container::before {
  left: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
}

.swiper-container::after {
  right: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
}

/* 调整导航按钮位置到中间 */
.custom-prev-btn,
.custom-next-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  font-size: 30px;
  cursor: pointer;
  z-index: 10;
}

.custom-prev-btn {
  left: 2%;
  // transform: translateX(-50%) translateY(-50%);
}

.custom-next-btn {
  right: 2%;
  // transform: translateX(-50%) translateY(-50%);
}

.swiper-img {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  object-fit: contain;
  // background:#000000;
}

.swiper-bottom-bg {
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 10;
}

::v-deep .swiper-pagination {
  text-align: center;
  margin-top: 20px;
  // background-image: url(../assets/images/bg-swiper-pagination.png);
  // background-size: cover;
  // background-repeat: no-repeat;
  padding-bottom: 10px;
  margin-bottom: -10px;
}

/* 自定义圆点样式 */
::v-deep .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: rgba(230, 230, 230, 0.8);
  opacity: 1; // 取消默认透明度
  border-radius: 50%;
  margin: 0 5px;
}

/* 激活状态样式 */
::v-deep .my-swiper-pagination-active {
  background: #ffffff;
  box-shadow:0px 0px 3px 0px #e0e0e0;
}

/**Swiper样式调整结束 */
@media (min-width: 1280px) and (max-width: 1679px) {
  .article-container {
    .main {
      margin-top: 20px;
      padding: 0 72px;

      .return-btn {
        margin-top: 20px;
        height: 19.8px;
      }

      .content-container {
        width: 990px;
        border-top-left-radius: 18px;
        padding: 13.5px 0 13.5px 13.5px;

        .img-video {
          width: 558px;
          height: 747px;
          border-radius: 9px;
        }

        .desc-container {
          width: calc(990px - 558px);
          margin-left:22.5px;

          .right-top {
            margin-top: 14.4px;
            // padding-left: 36.9px;
            padding-bottom: 18px;
            padding-right: 18px;

            .nick-avatar-box {
              .avatar {
                width: 36px;
                height: 36px;
              }

              .nick-box {
                margin-left: 9px;

                .nick {
                  font-size: 14px;
                }

                .job {
                  font-size: 10px;
                }
              }
            }

            .btn-box {
              .like-box {
                margin: 0 3.6px;
                width: 36px;
                height: 36px;
                border-radius: 9px;
                .like-icon {
                  width: 16.2px;
                  height: 16.2px;
                }

                .like-num {
                  font-size: 9px;
                }
              }

              .favorite-box {
                margin: 0 3.6px;
                width: 36px;
                height: 36px;
                border-radius: 9px;

                .favorite-icon {
                  width: 16.2px;
                  height: 16.2px;
                }

                .favorite-num {
                  font-size: 9px;
                }
              }

              .pop-share {
                .link-icon {
                  width: 16.2px;
                  height: 16.2px;
                  margin-right: 4.5px;
                }
              }

              .share-btn {
                margin: 0 7.2px;
                width: 36px;
                height: 36px;
                border-radius: 9px;

                .share-icon {
                  width: 12.6px;
                  height: 13.5px;
                }
              }

              .follow-btn {

                // width: 68.4px;
                // height: 36px;
              }
              .unfollow-btn {

                // width: 68.4px;
                // height: 36px;
              }
            }
          }

          .content-box {
            max-height: 578.7px;
            .content-main {
              // padding: 27px 31.5px 0 31.5px;
              padding:22.5px 0 0 0;
              .content-title {
                font-size: 16px;
              }

              .time-view-box {
                font-size: 12px;
                margin-top: 9px;

                .time {
                  margin-right: 18px;
                }

                .view-box {
                  .view-icon {
                    width: 17.1px;
                    height: 17.1px;
                  }
                }
              }

              .desc-content {
                font-size: 14px;
                margin-top: 27px;
                padding-bottom: 18px;
              }

              .comment-box {
                margin-top: 18px;

                .comment-title {
                  font-size: 14px;

                  .comment-count {
                    font-size: 12px;
                  }
                }

                .comment-main {
                  margin-top: 18px;

                  .comment-item-box {
                    margin-bottom: 22.5px;
                    .comment-avatar {
                      width: 36px;
                      height: 36px;
                      margin-right: 9px;
                    }

                    .comment-nick {
                      margin-right: 9px;
                      font-size: 14px;
                      max-width: 180px;

                      .comment-nick-tag {
                        margin-left: 9px;
                        margin-right: 13.5px;
                        border-radius: 9px;
                        font-size: 10px;
                        padding: 4.5px;
                      }
                    }

                    .comment-content {
                      font-size: 14px;
                    }

                    .comment-time {
                      margin-top: 4.5px;
                      font-size: 10px;
                    }

                    .comment-like-count {
                      margin-top: 9px;

                      .comment-like-count-item-left {
                        // margin-right: 18px;
                      }

                      .like-count-icon {
                        width: 16.2px;
                        height: 16.2px;
                        margin-right: 4.5px;
                      }
                    }

                    .comment-child-box {
                      margin-top: 18px;

                      .nick-box {
                        .nick-container {
                          .comment-nick {
                            margin-right: 9px;
                            font-size: 14px;
                            max-width: 162px;

                            .comment-nick-tag {
                              margin-left: 9px;
                              border-radius: 9px;
                              font-size: 10px;
                              padding: 4.5px;
                            }
                          }
                          .comment-nick-tag {
                            margin-left: 9px;
                            border-radius: 9px;
                            font-size: 10px;
                            padding: 4.5px;
                          }
                        }
                      }

                      .comment-avatar {
                        width: 36px;
                        height: 36px;
                        margin-right: 9px;
                      }

                      .comment-content {
                        font-size: 14px;
                      }

                      .comment-time {
                        margin-top: 4.5px;
                        font-size: 10px;
                      }

                      .comment-like-count-box {
                        margin-top: 9px;

                        .comment-like-count-item-left {
                          // margin-right: 18px;
                        }

                        .comment-like-count-icon {
                          width: 16.2px;
                          height: 16.2px;
                          margin-right: 4.5px;
                        }
                      }
                    }

                    .more-comment {
                      font-size: 12px;
                      margin-top: 9px;
                    }
                  }
                }
              }
            }
          }

          .reply-box{
            margin-top:18px;
            margin-left:18.9px;
            font-size:12px;
          }

          .comment-form {
            padding: 18px 18px 18px 0;

            .comment-input-box {
              height: 40.5px;
              border-radius: 20.7px;

              .comment-input {
                margin-left: 18px;
                padding-right: 18px;
              }
            }

            .function-box {
              margin-top: 9px;

              .icon-emoji {
                width: 26px;
                height: 26px;
                margin-left: 20px;
                background-image: url(../assets/images/icon-emoji-list-popup.png);
                background-repeat: no-repeat;
                background-size: cover;
                border: none;
                &:focus{
                    border:none !important;
                }
              }

              Button {
                background: transparent;
                border:none;
              }

              .emoji-picker {
                position: absolute;
                z-index: 1;
                font-family: Montserrat;
                border: 1px solid #ccc;
                width: 30rem;
                height: 20rem;
                overflow: scroll;
                padding: 1rem;
                box-sizing: border-box;
                border-radius: 0.5rem;
                background: #fff;
                box-shadow: 1px 1px 8px #c7dbe6;
                top: 340px !important;
                left: 730px !important;
              }
              .form-btn-box{
                .cancel-btn{
                  border-radius:10px;
                  margin-right:10px;
                }
                .submit-btn {
                  background: #ff5967;
                  border: none;
                  color: #ffffff;
                  border-radius: 10px;
                }
              }
            }
          }
        }
      }
    }
  }

  ::v-deep .ivu-poptip-arrow:after {
    border-bottom-color: rgba(0, 0, 0, 0.9) !important;
  }

  ::v-deep .ivu-poptip-inner {
    background-color: rgba(0, 0, 0, 0.9) !important;
    border-radius: 15px;
  }

  /**swiper样式调整开始 */
  .swiper-container {
    position: relative;
    /* 确保按钮定位参考容器 */
    width: 100%;
    height: 747px;
    overflow: hidden;
    border-radius: 10px;
    /* 允许前后幻灯片溢出显示 */
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* 幻灯片宽度占容器的 80% */
    // background: #000000;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .swiper-container::before {
    left: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
  }

  .swiper-container::after {
    right: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
  }

  /* 调整导航按钮位置到中间 */
  .custom-prev-btn,
  .custom-next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    z-index: 10;
  }

  .custom-prev-btn {
    left: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .custom-next-btn {
    right: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .swiper-img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .swiper-bottom-bg {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
  }

  ::v-deep .swiper-pagination {
    text-align: center;
    margin-top: 20px;
    // background-image: url(../assets/images/bg-swiper-pagination.png);
    background-size: cover;
    background-repeat: no-repeat;
    padding-bottom: 10px;
    margin-bottom: -10px;
  }

  /* 自定义圆点样式 */
  ::v-deep .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: rgba(0, 0, 0, 0.6);
    opacity: 1; // 取消默认透明度
    border-radius: 50%;
    margin: 0 5px;
  }

  /* 激活状态样式 */
  ::v-deep .my-swiper-pagination-active {
    background: #ffffff;
  }
}

@media (max-width: 1279px) {
  .article-container {
    .main {
      margin-top: 24px;
      padding: 0 64px;

      .return-btn {
        margin-top: 24px;
        height: 17.6px;
      }

      .content-container {
        width: 880px;
        padding: 12px 0 12px 12px;

        .img-video {
          width: 496px;
          height: 664px;
        }

        .desc-container {
          width: calc(880px - 496px);
          margin-left:20px;

          .right-top {
            margin-top: 14.4px;
            // padding-left: 32.8px;
            padding-bottom: 16px;
            padding-right: 16px;

            .nick-avatar-box {
              .avatar {
                width: 32px;
                height: 32px;
              }
              .nick-box {
                margin-left: 8px;
                .nick {
                  font-size: 14px;
                }

                .job {
                  font-size: 10px;
                }
              }
            }

            .btn-box {
              .like-box {
                margin: 0 3.2px;
                width: 32px;
                height: 32px;
                border-radius: 8px;

                .like-icon {
                  width: 14.4px;
                  height: 14.4px;
                }

                .like-num {
                  font-size: 9px;
                }
              }

              .favorite-box {
                margin: 0 3.2px;
                width: 32px;
                height: 32px;
                border-radius: 8px;

                .favorite-icon {
                  width: 14.4px;
                  height: 14.4px;
                }

                .favorite-num {
                  font-size: 9px;
                }
              }

              .pop-share {
                .link-icon {
                  width: 14.4px;
                  height: 14.4px;
                  margin-right: 4px;
                }
              }

              .share-btn {
                margin: 0 6.4px;
                width: 32px;
                height: 32px;
                border-radius: 8px;

                .share-icon {
                  width: 11.2px;
                  height: 12px;
                }
              }

              .follow-btn {
                // border-radius: 8px;
                // width: 60.8px;
                // height: 32px;
              }
              .unfollow-btn {
                // border-radius: 8px;
                // width: 60.8px;
                // height: 32px;
              }
            }
          }

          .content-box {
            width: 100%;
            max-height: 514.4px;
            .content-main {
              padding: 20px 0 0 0;
              .content-title {
                font-size: 16px;
              }

              .time-view-box {
                font-size: 12px;
                margin-top: 8px;

                .time {
                  margin-right: 16px;
                }

                .view-box {
                  .view-icon {
                    width: 15.2px;
                    height: 15.2px;
                  }
                }
              }

              .desc-content {
                font-size: 14px;
                margin-top: 24px;
                padding-bottom: 16px;
              }

              .comment-box {
                margin-top: 16px;
                width: 100%;

                .comment-title {
                  font-size: 14px;

                  .comment-count {
                    font-size: 12px;
                  }
                }

                .comment-main {
                  margin-top: 16px;

                  .comment-item-box {
                    margin-bottom: 20px;
                    .comment-avatar {
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      margin-right: 8px;
                    }

                    .comment-nick {
                      margin-right: 8px;
                      font-size: 14px;
                      max-width: 160px;

                      .comment-nick-tag {
                        margin-left: 8px;
                        margin-right: 12px;
                        border-radius: 8px;
                        font-size: 10px;
                        padding: 4px;
                      }
                    }

                    .comment-content {
                      font-size: 14px;
                    }

                    .comment-time {
                      margin-top: 4px;
                      font-size: 10px;
                    }

                    .comment-like-count {
                      margin-top: 8px;

                      .comment-like-count-item-left {
                        // margin-right: 16px;
                      }

                      .like-count-icon {
                        width: 14.4px;
                        height: 14.4px;
                        margin-right: 4px;
                      }
                    }

                    .comment-child-box {
                      margin-top: 16px;

                      .nick-box {
                        .nick-container {
                          width: 100%;
                          .comment-nick {
                            margin-right: 8px;
                            font-size: 14px;
                            max-width: 144px;

                            .comment-nick-tag {
                              margin-left: 8px;
                              border-radius: 8px;
                              font-size: 10px;
                              padding: 4px;
                            }
                          }
                          .comment-nick-tag {
                            margin-left: 8px;
                            border-radius: 8px;
                            font-size: 10px;
                            padding: 4px;
                          }
                        }
                      }

                      .comment-avatar {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        margin-right: 8px;
                      }

                      .comment-content {
                        font-size: 14px;
                      }

                      .comment-time {
                        margin-top: 4px;
                        font-size: 10px;
                      }

                      .comment-like-count-box {
                        margin-top: 8px;

                        .comment-like-count-item-left {
                          // margin-right: 16px;
                        }

                        .comment-like-count-icon {
                          width: 14.4px;
                          height: 14.4px;
                          margin-right: 4px;
                        }
                      }
                    }

                    .more-comment {
                      font-size: 12px;
                      margin-top: 8px;
                    }
                  }
                }
              }
            }
          }

          .reply-box{
            margin-top:16px;
            margin-left:16.8px;
            font-size:12px;
          }
          .comment-form {
            padding: 16px 16px 16px 0;

            .comment-input-box {
              height: 36px;
              border-radius: 18.4;

              .comment-input {
                margin-left: 16px;
                padding-right: 16px;
              }
            }

            .function-box {
              margin-top: 8px;
              .icon-emoji {
                width: 20.8px;
                height: 20.8px;
                margin-left: 16px;
              }

              .emoji-picker {
                top: 280px !important;
                left: 624px !important;
              }

              .submit-btn {
                border-radius: 8px;
              }
            }
          }
        }
      }
    }
  }

  ::v-deep .ivu-poptip-arrow:after {
    border-bottom-color: rgba(0, 0, 0, 0.9) !important;
  }

  ::v-deep .ivu-poptip-inner {
    background-color: rgba(0, 0, 0, 0.9) !important;
    border-radius: 15px;
  }

  /**swiper样式调整开始 */
  .swiper-container {
    /* 确保按钮定位参考容器 */
    height: 664px;
    border-radius: 8px;
    /* 允许前后幻灯片溢出显示 */
  }

  /* 调整导航按钮位置到中间 */
  .custom-prev-btn,
  .custom-next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-70%);
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    z-index: 10;
  }

  .custom-prev-btn {
    left: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .custom-next-btn {
    right: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .swiper-img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .swiper-bottom-bg {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
  }

  ::v-deep .swiper-pagination {
    text-align: center;
    margin-top: 20px;
    // background-image: url(../assets/images/bg-swiper-pagination.png);
    background-size: cover;
    background-repeat: no-repeat;
    padding-bottom: 10px;
    margin-bottom: -10px;
  }

  /* 自定义圆点样式 */
  ::v-deep .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: rgba(0, 0, 0, 0.6);
    opacity: 1; // 取消默认透明度
    border-radius: 50%;
    margin: 0 5px;
  }

  /* 激活状态样式 */
  ::v-deep .my-swiper-pagination-active {
    background: #ffffff;
  }

  /**Swiper样式调整结束 */
}
</style>
